import { Stack, Typography } from "@mui/material";

const ArticleTitle = ({
    title,
    subtitle,
    customSpacing,
}: {
    title: string;
    subtitle?: string;
    customSpacing?: number;
}) => {
    return (
        <Stack spacing={customSpacing || 2}>
            <Typography variant="h2">{title}</Typography>
            {subtitle && <Typography variant="h5">{subtitle}</Typography>}
        </Stack>
    );
};

export default ArticleTitle;
